import { StudentFeeReport, StudentFeeReportActionList, StudentFeeReportActions } from "../actions/studentFeeReport";
import { Action } from "../actions/types";


const initialValue : Array<StudentFeeReport> = []

const studentFeeReportReducer = (state:Array<StudentFeeReport>=
    initialValue,action: StudentFeeReportActions
)=>{
    switch(action.type) {
        case StudentFeeReportActionList.FETCH_STUDENT_FEE_REPORT:
            
               return action.data;  
            case StudentFeeReportActionList.CLEAR_STUDENT_FEE_REPORT:
            
            return [];

                default:
            return state;
    }
}
export default studentFeeReportReducer;


